import React, { Component } from 'react';
import Joyride, { STATUS } from 'react-joyride';
import FrameworkButtons from '../components/framework-buttons/FrameworkButtons';

import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import LoginForm from './login-form/LoginForm';
import Footer from '../components/Footer';
import { login } from '../services/auth/auth';
import Association from './Association';
import masterListSource from './MasterList';
import auth from '../services/util/auth';
import { MetaTags } from 'react-meta-tags';
import { Helmet } from 'react-helmet';
import ProfilesHomepage from '../containers/ProfilesHomepage';

class Frameworks extends Component {
  state = {
    frameworks: [],
    runTour: false,
    tourSteps: [
      {
        target: '#vf-form__select',
        title: 'Find your area',
        content: 'Choose a life science area to see relevant career profiles.',
        placement: 'left',
        disableBeacon: true
      },
      {
        target: '#profile_to_highlight',
        title: 'Explore career profiles',
        content:
          'Discover roles in the life sciences and explore the competencies associated with each.',
        placement: 'left',
        disableBeacon: true
      },
      {
        target: '#create-your-profile',
        title: 'Build your own profile',
        content:
          'Assess your competencies, compare your profile with other profiles and find training resources to help fill gaps.',
        placement: 'left',
        disableBeacon: true
      },
      {
        target: '#explore-competencies',
        title: 'Explore competency frameworks',
        content:
          'Choose a framework to explore the knowledge, skills and behaviours relevant to your field and identify areas for professional development.',
        placement: 'left'
      },
      {
        target: '#sites',
        title: 'Understand minimum standards',
        content:
          'Discover the baseline competencies for biomedical data science.',
        placement: 'left'
      }
    ]
  };
  static propTypes = {
    user: PropTypes.string,
    roles: PropTypes.string,
    onLogin: PropTypes.func,
    onLogout: PropTypes.func
  };

  handleJoyrideCallback = data => {
    const { status, action } = data;
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      this.setState({ runTour: false });
    }
    // Close tour when close button is clicked
    if (action === 'close') {
      this.setState({ runTour: false });
    }
  };

  startTour = e => {
    e.preventDefault();
    this.setState({ runTour: true });
  };

  onLogin = (username, password) => {
    this.handleLogin(username, password);
  };

  onLogout = () => {
    this.props.onLogout();
  };

  handleLogin = async (username, password) => {
    try {
      await login(username, password);
      document.location.reload();
    } catch (error) {
      window.console.error(error);
      if (error.response) {
        switch (error.response.status) {
          case 400:
            window.alert(error.response.data.message);
            return;
          default:
            window.alert(
              'Sorry, there was an unknown login problem, please try again.'
            );
        }
        window.alert(
          'Sorry, there was an unknown login problem, please try again.'
        );
      }
    }
  };

  render() {
    return (
      <div>
        <Joyride
          steps={this.state.tourSteps}
          run={this.state.runTour}
          continuous
          showProgress
          disableScrolling
          disableScrollParentFix
          scrollToFirstStep={false}
          scrollOffset={0}
          hideCloseButton={false}
          callback={this.handleJoyrideCallback}
          styles={{
            options: { zIndex: 10000, width: 380, primaryColor: '#3b6fb6' },
            spotlight: {
              borderRadius: 8,
              border: '2px solid #ffffff',
              backgroundColor: 'rgba(255, 255, 255, 0.15)'
            }
          }}
        />
        <MetaTags>
          <title>Competency hub</title>
          <meta property="og:title" content="Competency hub" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://competemcy.ebi.ac.uk" />
          <meta
            property="og:image"
            content="https://acxngcvroo.cloudimg.io/v7/https://cms.competency.ebi.ac.uk/themes/custom/ebi_academy/images/mastheads/CH_Jigsaw.jpg"
          />
          <meta
            property="og:description"
            content="The Competency Hub is a repository of competency frameworks that define the abilities required by professionals in a specific area of life sciences and relate them to training resources and career profiles"
          />
          <meta
            name="description"
            content="The Competency Hub is a repository of competency frameworks that define the abilities required by professionals in a specific area of life sciences and relate them to training resources and career profiles"
          />
          <meta
            property="keywords"
            content="competency, life sciences, career development, computational biology, bioinformatics"
          />
        </MetaTags>
        <Helmet>
          <link rel="canonical" href={this.props.location.pathname} />
        </Helmet>
        <section
          className="vf-card-container vf-card-container__col-3 | vf-u-background-color--grey--lightest vf-u-fullbleed"
          data-vf-google-analytics-region="home-actions-links"
          style={{
            '--vf-card__image--aspect-ratio': '16 / 9',
            top: '-2rem',
            '--vf-stack-margin': '0'
          }}
        >
          <div className="vf-card-container__inner">
            <h2 className="vf-section-header__heading vf-section-header__heading--is-link vf-u-sr-only">
              Homepage quicklinks
            </h2>
            <article className="vf-card vf-card--brand vf-card--bordered">
              <div className="vf-card__content | vf-stack vf-stack--400">
                <h3 className="vf-card__heading">
                  <a
                    className="vf-card__link"
                    href="/submission"
                    onClick={e => this.startTour(e)}
                  >
                    Take a quick tour
                    <svg
                      aria-hidden="true"
                      className="vf-card__heading__icon | vf-icon vf-icon-arrow--inline-end"
                      width="1em"
                      height="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0C5.376.008.008 5.376 0 12zm13.707-5.209l4.5 4.5a1 1 0 010 1.414l-4.5 4.5a1 1 0 01-1.414-1.414l2.366-2.367a.25.25 0 00-.177-.424H6a1 1 0 010-2h8.482a.25.25 0 00.177-.427l-2.366-2.368a1 1 0 011.414-1.414z"
                        fill="currentColor"
                        fillRule="nonzero"
                      />
                    </svg>
                  </a>
                </h3>
              </div>
            </article>
            <article className="vf-card vf-card--brand vf-card--bordered">
              <div className="vf-card__content | vf-stack vf-stack--400">
                <h3 className="vf-card__heading">
                  <a className="vf-card__link" href="/about">
                    About Competency hub{' '}
                    <svg
                      aria-hidden="true"
                      className="vf-card__heading__icon | vf-icon vf-icon-arrow--inline-end"
                      width="1em"
                      height="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0C5.376.008.008 5.376 0 12zm13.707-5.209l4.5 4.5a1 1 0 010 1.414l-4.5 4.5a1 1 0 01-1.414-1.414l2.366-2.367a.25.25 0 00-.177-.424H6a1 1 0 010-2h8.482a.25.25 0 00.177-.427l-2.366-2.368a1 1 0 011.414-1.414z"
                        fill="currentColor"
                        fillRule="nonzero"
                      />
                    </svg>
                  </a>
                </h3>
              </div>
            </article>
            {document.location.hostname === 'localhost' ||
            document.location.hostname === 'dev.competency' ? (
              <article className="vf-card vf-card--brand vf-card--bordered">
                <div className="vf-card__content | vf-stack vf-stack--400">
                  <h3 className="vf-card__heading">
                    <a className="vf-card__link" href="/">
                      Read the tutorial{' '}
                      <svg
                        aria-hidden="true"
                        className="vf-card__heading__icon | vf-icon vf-icon-arrow--inline-end"
                        width="1em"
                        height="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0C5.376.008.008 5.376 0 12zm13.707-5.209l4.5 4.5a1 1 0 010 1.414l-4.5 4.5a1 1 0 01-1.414-1.414l2.366-2.367a.25.25 0 00-.177-.424H6a1 1 0 010-2h8.482a.25.25 0 00.177-.427l-2.366-2.368a1 1 0 011.414-1.414z"
                          fill="currentColor"
                          fillRule="nonzero"
                        />
                      </svg>
                    </a>
                  </h3>
                </div>
              </article>
            ) : (
              <div />
            )}
          </div>
        </section>
        {/* <div className="vf-banner vf-banner--alert vf-banner--info" style={{"--vf-stack-margin":"0"}}>
          <div className="vf-banner__content">
            <p className="vf-banner__text">New to competency hub? 
              <button className="vf-button vf-button--link" onClick={this.startTour}>
                Take a quick tour
              </button>
            </p>
          </div>
        </div> */}
        <div id="discover-career-profiles">
          <h2>Discover career profiles in life sciences</h2>
          <ProfilesHomepage />
        </div>
        <div className="vf-u-padding__top--800" />
        <section className="vf-u-fullbleed vf-u-background-color-ui--grey--light vf-u-padding__top--800">
          <div id="explore-competencies">
            <h2>
              Explore competencies, training resources and career profiles
            </h2>
          </div>
          <FrameworkButtons frameworkDetails={masterListSource} />

          <div className="vf-u-padding__top--800" />
          <h3 className="vf-u-sr-only">
            Explore competencies, training resources and career profiles
          </h3>
          <hr />
          <div id="sites">
            <div className="vf-section-header">
              <h2 className="vf-section-header__heading">
                {' '}
                Explore minimum standards
              </h2>
            </div>
            <br />
            <div className="vf-card-container__inner vf-grid vf-grid__col-3 minimum-standards">
              <article className="vf-card vf-card--brand vf-card--striped">
                <img
                  src="https://acxngcvroo.cloudimg.io/v7/https://cms.competency.ebi.ac.uk/sites/default/files/2026-06/ABDC_icon.jpg"
                  alt=""
                  className=""
                  loading="lazy"
                />
                <div className="vf-card__content | vf-stack vf-stack--400">
                  <h3 className="vf-card__heading">
                    <a className="vf-card__link" href="/framework/abdc/1.0">
                      Biomedical data science
                      <svg
                        aria-hidden="true"
                        className="vf-card__heading__icon | vf-icon vf-icon-arrow--inline-end"
                        width="1em"
                        height="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0C5.376.008.008 5.376 0 12zm13.707-5.209l4.5 4.5a1 1 0 010 1.414l-4.5 4.5a1 1 0 01-1.414-1.414l2.366-2.367a.25.25 0 00-.177-.424H6a1 1 0 010-2h8.482a.25.25 0 00.177-.427l-2.366-2.368a1 1 0 011.414-1.414z"
                          fill="currentColor"
                          fillRule="nonzero"
                        />
                      </svg>
                    </a>
                  </h3>
                  <p className="vf-card__text">
                    Discover the core competencies and professional profiles
                    required across the modern biomedical data science
                    ecosystem.
                  </p>
                </div>
              </article>
              <div className="minimum-standards-text vf-grid__col--span-2">
                Minimum standards establish the foundational competencies
                required to ensure quality, reproducibility, and safety across
                specialised professional domains. Rather than defining
                everything an expert needs to know, these baselines provide a
                clear, shared reference point that helps individual
                professionals, teams, and training providers align their
                expectations.
                <br />
                <br /> Adopting these standards enables more transparent career
                planning, robust competence assessment, and the future design of
                targeted training solutions, ultimately fostering a more capable
                and collaborative interdisciplinary ecosystem.
              </div>
            </div>
          </div>
          <div className="vf-u-padding__top--800" />
        </section>

        <div className="vf-u-margin__top--1200" />
        <h2>In association with</h2>
        <div className="vf-grid vf-grid__col-4">
          {masterListSource
            .filter(item => item.show_logo_association_with === true)
            .map((framework, key) => {
              // VF Grid Col 5
              return <Association framework={framework} key={key} />;
            })}
        </div>
        <div className="vf-u-margin__top--800" />
        <Footer />
        <div>
          {auth.currently_logged_in_user.is_logged_in ? (
            <div>
              <p>
                You are logged-in {' | '}
                <a
                  className="vf-link"
                  href="https://www.ebi.ac.uk/data-protection/privacy-notice/competency-hub"
                >
                  Privacy notice for the Competency Hub
                </a>
              </p>
            </div>
          ) : (
            <LoginForm onSubmit={this.onLogin} />
          )}
        </div>

        <div className="vf-u-margin__top--200" />
        <p>
          Contact us at competency [at] ebi.ac.uk if you have any questions,
          comments or suggestions.
        </p>
      </div>
    );
  }
}

export default withSnackbar(Frameworks);
